import { bonusClaimDurationOptions } from "../../../modules/BonusDistribution/constants";

export const parseExpirationIntreval = (interval: string = "") => {
  const [
    claimable_number = 1,
    claimable_period = bonusClaimDurationOptions[0],
  ] = interval?.split(" ");

  return {
    claimable_number,
    claimable_period,
  };
};
